<template>
  <div class="available-data-message">
    Ultimo dato disponibile: {{ formattedDate }}
  </div>
</template>

<script>
const DATE_FORMAT = 'DD/MM/YYYY';

export default {
  props: {
    date: {
      required: true,
      type: Object,
    },
  },

  computed: {
    formattedDate() {
      return this.date.format(DATE_FORMAT);
    },
  },
}
</script>

<style scoped>
.available-data-message {
  font-size: 12px;
  position: absolute;
  bottom: 10px;
  left: 14px;
  right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/ux/LastAvailableDataDateLabel.vue